var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.visitTypeLoaded
        ? _c("DropdownFilter", {
            attrs: {
              withoutLoading: "",
              noOptionsText: "Start typing",
              placeholder: "Select type of visit",
              loading: _vm.$apollo.queries.visitType.loading,
              value: _vm.selectedTypeOfVisit,
              multiple: false,
              invalid: _vm.invalid,
              options: _vm.visitType,
              customMultiStyleParent: _vm.getcontainerStyle,
            },
            on: { input: _vm.handleSelection },
          })
        : _c("InputPlaceholder"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }